import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const ListGroup = (props: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 20V19C1 14.5817 4.58172 11 9 11"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M15 11C19.4183 11 23 14.5817 23 19V20"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <circle cx="9" cy="6" r="3" stroke="currentColor" />
    <circle cx="15" cy="6" r="3" stroke="currentColor" />
  </svg>
);

export default ListGroup;
